import { useState, useEffect } from 'react'
import { contactsAPI } from '../services/api'
import { useNotification } from '../context/NotificationContext'
import { getErrorMessage, confirmAction } from '../utils/helpers'

const Contacts = () => {
  const { showSuccess, showError } = useNotification()
  const [contacts, setContacts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchContacts()
  }, [])

  const fetchContacts = async () => {
    try {
      const response = await contactsAPI.getAll()
      setContacts(response.data.contacts || [])
    } catch (error) {
      showError(getErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  const handleToggleRead = async (id) => {
    try {
      await contactsAPI.toggleRead(id)
      fetchContacts()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  const handleDelete = async (id) => {
    if (!confirmAction('Delete this message?')) return
    
    try {
      await contactsAPI.delete(id)
      showSuccess('Message deleted.')
      fetchContacts()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  if (loading) return <div className="admin-page">Loading...</div>

  return (
    <div className="admin-page">
      <h2 className="admin-title">Messages</h2>
      <p className="admin-sub">View and manage contact form submissions</p>

      <div className="panel">
        {contacts.length > 0 ? (
          contacts.map((contact) => (
            <div key={contact.id} className={`contact-msg ${contact.read === 0 ? 'unread' : ''}`}>
              <div className="msg-head">
                <div>
                  <strong>{contact.name}</strong>
                  {contact.email && <span className="muted"> • {contact.email}</span>}
                  {contact.subject && <div className="muted">{contact.subject}</div>}
                </div>
                <div className="msg-actions">
                  <span className="muted">{new Date(contact.created_at).toLocaleDateString()}</span>
                  <button onClick={() => handleToggleRead(contact.id)} className="btn btn-sm btn-outline-secondary">
                    <i className={`fa fa-${contact.read ? 'envelope-open' : 'envelope'}`}></i> 
                    {contact.read ? ' Mark Unread' : ' Mark Read'}
                  </button>
                  <button onClick={() => handleDelete(contact.id)} className="btn btn-sm btn-danger">
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
              </div>
              <p>{contact.message}</p>
            </div>
          ))
        ) : (
          <p className="muted">No messages yet.</p>
        )}
      </div>
    </div>
  )
}

export default Contacts
